import { Link } from "react-router-dom";
import { JandiLogo } from "../components/assets/logos/svgs";

import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title: "Página no encontrada || Jandi ",
  description: "Jandi ",
};

const NotFoundPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <div
        className="error-page-wrapper "
        style={{
          backgroundImage: `url(/images/404.jpg)`,
        }}
        data-aos="fade"
      >
        <div className="content">
          <div className="logo">
            <Link to="/">
              <JandiLogo />
            </Link>
          </div>
          {/* End logo */}

          <h1>404!</h1>
          <p>La página que estás buscando no pudo ser encontrada.</p>

          <Link
            className="theme-btn btn-style-three call-modal"
            to="/"
            style={{ padding: "10px 20px" }}
          >
            VOLVER AL INICIO
          </Link>
        </div>
        {/* End .content */}
      </div>
    </>
  );
};

export default NotFoundPage;
